export const uploadToCloudinary = async (file: any, folderName: string) => {
  // Cloudinary expects multipart/form-data
  const data = new FormData();

  // Ensure file has the required fields: uri, name, and type
  // (Depending on how your `UploadFile` component returns the file object)
  const blob = new Blob([file], { type: file.type || 'image/jpeg' });
  data.append('file', blob, file.name || 'photo.jpg'); // fallback name
  data.append('upload_preset', 'suncrop');
  data.append('folder', folderName);

  try {
    const res = await fetch(
      'https://api.cloudinary.com/v1_1/dmetfxrjv/image/upload',
      {
        method: 'POST',
        body: data,
      },
    );
    const json = await res.json();
    if (json.error) {
      throw json.error;
    }

    return json.secure_url;
  } catch (error) {
    throw error;
  }
};
